"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var LocalDatePipe = /** @class */ (function () {
    function LocalDatePipe(httpLocaleService, _currentLanguageProvider) {
        this.httpLocaleService = httpLocaleService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.format = {
            date: 'date',
            dateTime: 'dateTime',
            time: 'time'
        };
    }
    LocalDatePipe.prototype.transform = function (date, format) {
        var _this = this;
        if (format === void 0) { format = this.format.dateTime; }
        var currentLanguageObservable = this._currentLanguageProvider.getCurrentLanguage();
        if (date == null || typeof date !== "number") {
            return null;
        }
        switch (format) {
            case this.format.date:
                return currentLanguageObservable.mergeMap(function (lang) { return Observable_1.Observable.from(_this.httpLocaleService.formatDate(date, lang.getId())); });
            case this.format.dateTime:
                return currentLanguageObservable.mergeMap(function (lang) { return Observable_1.Observable.from(_this.httpLocaleService.formatDateTime(date, lang.getId())); });
            case this.format.time:
                return currentLanguageObservable.mergeMap(function (lang) { return Observable_1.Observable.from(_this.httpLocaleService.formatTime(date, lang.getId())); });
        }
    };
    LocalDatePipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'sysLocalDate'
                },] },
    ];
    /** @nocollapse */
    LocalDatePipe.ctorParameters = function () { return [
        { type: idm_locale_service_client_js_1.LocaleService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
    ]; };
    return LocalDatePipe;
}());
exports.LocalDatePipe = LocalDatePipe;
//# sourceMappingURL=local-date.pipe.js.map